import React, { useContext } from 'react';
import { FdsChevron } from '../../../components/common/chevron/fds-chevron';
import { VehicleTabs } from '../../../components/sections/vehicle-portal/components/vehicle-tabs/vehicle-tabs';
import { useAnalytics } from '../../../hooks/use-analytics';
import { VehicleAttributes } from '../../../models/vehicle-attributes';
import siteMapService from '../../services/site-map-service/site-map-service';
import localStorageWrapper from '../../../components/utils/local-storage-wrapper/localStorageWrapper';
import { useHistory } from 'react-router-dom';
import ServerContext from '../../../contexts/serverContext';
import { isIMGTakataRoute } from './recalls-util';

interface Props {
    vehicleSelectorTabsLabels: any;
    isWebview: boolean;
    recallsContent: any;
    fmaLoginValueContent: any;
    recallsLandingLink: string;
    vinToSearch: string;
    setQueryVin: (vin: string) => void;
}

export const VehicleVinBackButton = (props: Props) => {
    const [fireEvents] = useAnalytics();
    const history = useHistory();
    const isImgTakataRoute = isIMGTakataRoute();
    const serverContext = useContext(ServerContext);
    const currentRoot = serverContext.root
        ? serverContext.root.substring(0, serverContext.root.length - 1)
        : '';
    const recallsResultsCtaClickEvent = isImgTakataRoute
        ? 'takata-recalls-results-cta'
        : 'recalls-results-cta';
    const handleVehicleChange = (
        _title: string,
        _selectedIndex: number,
        vehicleAttributes: VehicleAttributes
    ) => {
        if (vehicleAttributes.vin !== props.vinToSearch) {
            const vehicleChangePath: any = siteMapService
                .getPathFromRouterConfigs(
                    serverContext.currentLanguageRegionCode,
                    serverContext.brand,
                    'RecallsDetailsPage',
                    [],
                    isImgTakataRoute
                )
                .replace(':vin?/', '')
                .replace(':vinOrModel?/:year?/', '');
            localStorageWrapper.setItem(
                'USER_VIN',
                vehicleAttributes?.vin || ''
            );
            props.setQueryVin(vehicleAttributes?.vin || '');
            history.push(vehicleChangePath);
            window.scrollTo(0, 0);
        }
    };

    return (
        <>
            {!props.vehicleSelectorTabsLabels?.vehicleSelectorTabsTitle &&
                !props.isWebview && (
                    <div
                        className="vehicle-actions"
                        data-testid="vehicle-actions"
                    >
                        <div className="recalls-details__left-vehicle-actions">
                            <div className="recalls-details-button-container">
                                <span className="to-recalls-label">
                                    <a
                                        href={`${currentRoot}${props.recallsLandingLink}`}
                                        onClick={() => {
                                            fireEvents(
                                                recallsResultsCtaClickEvent,
                                                undefined,
                                                {
                                                    ctaType: 'enter a new vin',
                                                },
                                                false
                                            );
                                            sessionStorage.removeItem(
                                                'QUERY_VIN'
                                            );
                                            localStorage.removeItem('USER_VIN');
                                        }}
                                    >
                                        {
                                            props.recallsContent
                                                .detailsEnterNewVin
                                        }
                                    </a>
                                </span>
                                <FdsChevron
                                    className="to-recalls"
                                    direction="left"
                                    type="unfilled"
                                />
                            </div>
                            <VehicleTabs
                                page="VIN"
                                onChange={handleVehicleChange}
                                dropDownOnly={true}
                                dropDownPlaceholder={
                                    props.fmaLoginValueContent
                                        ?.noVehiclesMessage
                                }
                            />
                        </div>
                    </div>
                )}
        </>
    );
};
